import React, { useEffect, useState } from "react";
// import Navbar from "../Navbar";
// import FindLoan from "./FindLoan";
import Serve from "./Serve/Serve.jsx";
import Types from "./Types/Types.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoanConsolidationEligibility from "./PersonalLoanEligibility/LoanConsolidationEligibility.jsx";
import PersonalLoanEligibility from "./PersonalLoanEligibility/PersonalLoanEligibility.jsx";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const LoanEligibilityForm = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const [loanApplyType, setLoanApplyType] = useState(() => {
    if (pathname === "/personalloan/check-eligibility-form") {
      return "pl";
    } else if (pathname === "/carloan/check-eligibility-form") {
      return "cl";
    } else if (pathname === "/homeloan/check-eligibility-form") {
      return "hl";
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        {pathname === "/personalloan/check-eligibility-form" && (
          <title>Personal Loan Check Eligibility Form</title>
        )}
        {pathname === "/carloan/check-eligibility-form" && (
          <title>Car Loan Check Eligibility Form</title>
        )}
        {pathname === "/homeloan/check-eligibility-form" && (
          <title>Home Loan Check Eligibility Form</title>
        )}
      </Helmet>
      <PersonalLoanEligibility loanApplyType={loanApplyType} />

      <Serve loanApplyType={loanApplyType} />
      <Types loanApplyType={loanApplyType} />
      {/* <Footer /> */}
      <ToastContainer loanApplyType={loanApplyType} />
    </>
  );
};

export default LoanEligibilityForm;
